// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","453":"64aababc","455":"6a7f0448","977":"49234da2"}[chunkId] + ".chunk.js";
};